import React from 'react';
import { Taxonomy } from '@uncinc/react-drupal-core';

import './style.scss';

const ThemesAllOverview = ({ onLoadMore, pager, loading, entities, setCurrentPage, ...props }) => {
  return (
    <div className="View ThemesAllOverview">
      <div className="row no-gutters">
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const className = 'col-12 col-md-4 ThemesAllOverview__item-wrapper';

          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Taxonomy
                id={id}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ThemesAllOverview;
